module.exports = __webpack_public_path__ + "img/ic-file-csv-upload.fa1cbb2c.svg";